<div [ngClass]="isDesktop ? 'header-container' : 'mobile-header-container'">
  <ion-grid id="profile-header">
    <ion-row
      data-cy="desktop-breadcrumbs-container"
      *ngIf="isDesktop"
      class="breadcrumbs-container"
    >
      <ion-col>
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
      </ion-col>
    </ion-row>
    <ion-row data-cy="my-profile-title-text" class="ion-align-items-center">
      <ion-col size="8" class="ion-no-padding">
        <h2 data-cy="title-profile" class="section-title" translate>
          {{ 'i18n.common.myProfile' }}
        </h2>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
